module.exports = "https://lts-static.prod-my.games/promo/lp1/img/footer-logo.87915811.svg";